/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_100Inputs */

const vi_carrier_status_100 = /** @type {(inputs: Carrier_Status_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng đã tiếp nhận`)
};

/**

* @param {Carrier_Status_100Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_100 = /** @type {((inputs?: Carrier_Status_100Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_100Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_100(inputs)
});